import {
	ADD_SONG_TO_FAVORITES_LIST,
	DELETE_SELECTED_SONG,
	DELETE_SELECTED_SONG_REQUEST,
	DELETE_SELECTED_SONG_SUCCESS,
	EDIT_SONG,
	GET_ALL_SONGS_SUCCESS,
	GET_COUNTRY_ARTISTS_REQUEST,
	GET_COUNTRY_ARTISTS_SUCCESS,
	GET_COUNTRY_SONGS_REQUEST,
	GET_COUNTRY_SONGS_SUCCESS,
	GET_COUNTRIES_WITH_SONGS_SUCCESS,
	GET_GENRES_SUCCESS,
	GET_PLAYLIST_SONGS_REQUEST,
	GET_PLAYLIST_SONGS_SUCCESS,
	GET_RANDOM_SONGS_LIST_REQUEST,
	GET_RANDOM_SONGS_LIST_SUCCESS,
	// GET_SELECTED_COUNTRY_SONGS,
	GET_USER_FAVORITE_SONGS_SUCCESS,
	GET_USER_UPLOADED_SONGS_SUCCESS,
	REMOVE_SONG_FROM_FAVORITES_LIST,
	SELECT_SONG_TO_EDIT,
	SELECT_SONG_TO_VIEW_INFO,
	SET_SELECTED_COUNTRY,
	UPDATE_EDIT_SONG_VALUE
} from '../constants/songs-action-types';
import {countriesSongsMap} from '../../helpers/countriesSongsMap';
import _ from 'lodash';

const initialState = {
	allCountriesSongs: [],
	countriesGenres: [],
	countriesInfo: [],
	countriesSongs: [],
	countriesWithSongs: [],
	editSongForm: {},
	favoriteSongs: [],
	playlistSongsList: [],
	selectedCountryArtists: [],
	selectedCountrySongs: [],
	selectedSongToViewInfo: {},
	songsByIdLookup: [],
	userUploadedSongs: [],
	loadedCountryArtists: false,
	loadedCountrySongs: false,
	loadedRandomSongs: false,
	loadedPlaylistSongs: false,
	loadedUserUploadedSongs: false,
	songsByCountry: {},


	selectedCountryName: '',
	countriesSongsMap,
	selectedCountryProperties:{ },
	isCountrySelected: false,
	isSongBeingPlayed: false
	
};

export default function songsReducers(state = initialState, action) {

	if (action.type === GET_COUNTRY_SONGS_REQUEST) {

		const { countriesSongsMap, selectedCountryName:currentSelectedCountryName } = state;
		const { payload: { countrySelected } } = action;


		const obj = currentSelectedCountryName === countrySelected ? 
			{isCountrySelected:false, selectedCountryProperties:{}}:
			{
				isCountrySelected: true,
				selectedCountryProperties: countriesSongsMap[countrySelected]
			};

		return Object.assign({}, state, obj);
	}
	if (action.type === SET_SELECTED_COUNTRY) {
		const {selectedCountryName:currentSelectedCountryName} = state;
		const selectedCountryName = currentSelectedCountryName ===action.payload ? '': action.payload;
		return Object.assign({}, state, {
			selectedCountryName
		});
	}
	return state;
}
